"use client";

import { useState, useEffect } from "react";

export default function FadeTransition({ show, children }) {
  const [shouldRender, setShouldRender] = useState(show);

  useEffect(() => {
    if (show) setShouldRender(true);
    const timer = setTimeout(() => {
      if (!show) setShouldRender(false);
    }, 250); // Clean, quick transition
    return () => clearTimeout(timer);
  }, [show]);

  if (!shouldRender) return null;

  return (
    <div
      className={`transition-opacity duration-200 ease-out ${
        show ? "opacity-100" : "opacity-0"
      }`}
    >
      {children}
    </div>
  );
}
